module.exports = __webpack_public_path__ + "img/lf6.fecbcd90.png";